// extracted by mini-css-extract-plugin
module.exports = {"section":"shop_section__3adgE","cards":"shop_cards__-hhMm"};